import { createReducer } from '@sde/widgets-core/src/redux/helpers/createReducer';
import { storage } from '@uhg-abyss/web/tools/storage';
import {
  SET_BREADCRUMBS,
  REMOVE_BREADCRUMB,
  REMOVE_BREADCRUMBS,
} from './constants';

const initialState = () => {
  const savedState = null;

  return { activeBreadcrumbs: savedState || [] };
};

export const breadcrumbsReducer = createReducer(initialState(), {
  [SET_BREADCRUMBS]: (state, action) => {
    storage.session.set('breadcrumbs', [...action.payload]);
    return {
      activeBreadcrumbs: action.payload,
    };
  },
  [REMOVE_BREADCRUMB]: (state, action) => {
    const breadcrumbs = (state.activeBreadcrumbs || []).filter(
      (item) => item.id !== action.payload.id
    );
    storage.session.set('breadcrumbs', [...breadcrumbs]);
    return {
      activeBreadcrumbs: breadcrumbs,
    };
  },
  [REMOVE_BREADCRUMBS]: (state, action) => {
    const breadcrumbs = (state.activeBreadcrumbs || []).filter(
      (item) => !item.id.includes(action.payload)
    );
    storage.session.set('breadcrumbs', [...breadcrumbs]);
    return {
      activeBreadcrumbs: breadcrumbs,
    };
  },
});
